export default __webpack_public_path__ + "static/media/logi_7-min.d39d6e84.jpg";